module.exports = __webpack_public_path__ + "static/media/wear-lev.b4828806.png";